    // ===== Discount alert (dynamic) =====
    (function () {
      var el = document.getElementById('discountAlert');
      if (!el) return;
      var params = new URLSearchParams(window.location.search);
      var fromQuery = params.get('discount') === 'applied';
      var fromSession = false;
      try { fromSession = sessionStorage.getItem('discountApplied') === '1'; } catch (e) {}
      if (fromQuery || fromSession) {
        el.classList.add('is-active');
        try { sessionStorage.setItem('discountApplied', '1'); } catch (e) {}
      }
    })();

    // ===== Gallery =====
    (function () {
      var main = document.getElementById('heroMain');
      if (!main) return;
      var slides = Array.from(document.querySelectorAll('#galSlides span'));
      if (slides.length === 0) return;
      var idx = 0;
      function setActive(i) {
        idx = ((i % slides.length) + slides.length) % slides.length;
        var src = slides[idx].getAttribute('data-src');
        if (src) main.src = src;
      }
      var prev = document.getElementById('galPrev');
      var next = document.getElementById('galNext');
      if (prev) prev.addEventListener('click', function () { setActive(idx - 1); });
      if (next) next.addEventListener('click', function () { setActive(idx + 1); });
    })();

    // ===== Pack selector =====
    // Radios use name="pack" for visual state; the hidden #product-id-input (name="id") is what
    // the form submits as the variant ID. The hidden field is initialized in Liquid to match the
    // default-checked radio (driven by section.settings.default_pack_position). This handler
    // keeps the hidden field in sync as the user clicks different packs.
    (function () {
      var packs = document.querySelectorAll('.pack');
      var totalValue = document.getElementById('totalValue');
      var totalCompare = document.getElementById('totalCompare');
      var totalBadge = document.getElementById('totalBadge');
      var variantInput = document.getElementById('product-id-input');
      function select(pack) {
        packs.forEach(function (p) { p.classList.remove('is-checked'); });
        pack.classList.add('is-checked');
        var input = pack.querySelector('input[type="radio"]');
        if (input) input.checked = true;
        var price = pack.getAttribute('data-price');
        var compare = pack.getAttribute('data-compare');
        var save = pack.getAttribute('data-save');
        var vid = pack.getAttribute('data-variant-id');
        if (totalValue && price) totalValue.textContent = price;
        if (totalCompare && compare) totalCompare.textContent = compare;
        if (totalBadge && save) totalBadge.textContent = 'Save ' + save + '% Off';
        if (variantInput && vid) variantInput.value = vid;
      }
      packs.forEach(function (p) {
        p.addEventListener('click', function (e) {
          // Allow label default behavior but make sure we sync state
          select(p);
        });
      });
    })();

    // ===== Yard-size selector — show recommendation text (structure matches hellopest.org RodentRx PDP bedroom quiz) =====
    // Also fires a single GA4 event 'home_size_complete' on the first selection per session,
    // with parameters { quiz_id: 'MosquitoRx_control', selection: '<yard-size label>', recommendation: <trap count> }.
    // quiz_id is a registered GA4 custom dimension (same setup as antrx-lander-quiz's 'antrx_coverage') —
    // it separates this quiz from the AntRx PDP quiz ('AntRx_control') in reports without a page filter.
    (function () {
      var rec = document.getElementById('brsec-rec');
      var recText = document.getElementById('brsec-rec-text');
      if (!rec || !recText) return;
      // Yard size -> recommended pack size (hand-set, not area math;
      // mirrors the mosquitorx-control-lander size quiz exactly)
      var QUIZ_RECOMMENDATIONS = {
        '0.25': 3,    // 1/4 acre (3-pack)
        '0.5': 5,     // 1/2 acre (5-pack)
        '0.75': 5,    // 3/4 acre
        '1': 5,       // 1 acre
        '1.5': 10,    // 1.5 acres (10-pack)
        '2': 10       // 2+ acres top option; industrial note shown
      };
      var ga4Fired = false;
      document.querySelectorAll('.brsec__opt input').forEach(function (i) {
        i.addEventListener('change', function () {
          if (!i.checked) return;
          var qty = QUIZ_RECOMMENDATIONS[i.value] || 3;
          var unit = qty === 1 ? 'trap' : 'traps';
          recText.textContent = 'Recommended: ' + qty + ' ' + unit;
          rec.classList.add('is-visible');
          var note = document.getElementById('brsec-industrial-note');
          if (note) { note.hidden = (i.value !== '2'); }

          // GA4: fire once per session on first valid selection
          if (!ga4Fired && typeof gtag === 'function') {
            ga4Fired = true;
            var labelEl = i.parentNode.querySelector('label');
            // Use innerText so <br> inside the label is treated as a line break
            // (textContent would yield "3bedrooms" with no separator).
            var label = labelEl ? (labelEl.innerText || labelEl.textContent).replace(/\s+/g, ' ').trim() : i.value;
            try {
              gtag('event', 'home_size_complete', {
                quiz_id: 'MosquitoRx_control',
                selection: label,
                recommendation: qty
              });
            } catch (e) {}
          }
        });
      });
    })();

    // ===== Restore the CTA after a back/forward-cache restore =====
    // The submit handler below disables the button and relabels it "Redirecting...".
    // Chrome restores this page from the bfcache with that live DOM intact, so a
    // shopper who hit Checkout and then navigated BACK found a dead button still
    // reading "Redirecting..." — being disabled, it fired no submit event, so no
    // amount of clicking (or re-picking a pack) recovered it; only a hard reload.
    // Reset on pageshow. Unconditional rather than gated on e.persisted: a plain
    // load resets to the same label, so this is a no-op there, and it also covers
    // restores that some browsers perform without setting persisted.
    (function () {
      var ctas = [];
      document.querySelectorAll('form[id^="product-form"] button[type="submit"]').forEach(function (b) {
        ctas.push({ el: b, label: b.textContent });  // captured at load = pre-submit label
      });
      if (!ctas.length) return;
      window.addEventListener('pageshow', function () {
        ctas.forEach(function (c) { c.el.disabled = false; c.el.textContent = c.label; });
      });
    })();

    // ===== Checkout — swap in the selected pack, keep the rest of the cart =====
    // This used to navigate to the cart permalink /cart/<variant>:<qty>. Permalinks REPLACE the
    // whole cart, so anything else the shopper had added (Bait Refills) was silently dropped.
    // Now: clear only THIS product's lines, then add the selected variant, then checkout.
    //
    // "Product family" = data-product-id on the #product-section wrapper. Matching on product_id
    // rather than a list of rendered variant IDs is deliberate: the trap carries a 1-20 pack
    // ladder but this page renders only the first 4, so a pack added from the default product
    // page would otherwise survive and ship two different pack sizes in one order.
    //
    // Fallback: on ANY cart-API failure we fall back to the permalink. Losing a refill beats
    // losing the sale, and we must never land on /checkout with an empty cart — that is what
    // produced the old "Something went wrong" page. DO NOT append ?checkout=1 to the permalink;
    // on this store that scalar param triggers "expected String to be a Hash: checkout".
    document.querySelectorAll('form[id^="product-form"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var fd = new FormData(this);
        var id = parseInt(fd.get('id'), 10);
        var qty = parseInt(fd.get('quantity'), 10) || 1;
        if (!id) { this.submit(); return; }  // defensive: native fallback if hidden id is empty
        var btn = this.querySelector('button[type="submit"]');
        if (btn) { btn.textContent = 'Redirecting...'; btn.disabled = true; }

        var host = this.closest('[data-product-id]') || document.querySelector('[data-product-id]');
        var familyId = host ? parseInt(host.getAttribute('data-product-id'), 10) : 0;
        var permalink = '/cart/' + id + ':' + qty;
        var JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

        fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var updates = {};
            (cart.items || []).forEach(function (item) {
              if (familyId && item.product_id === familyId) { updates[item.key] = 0; }
            });
            if (!Object.keys(updates).length) { return null; }
            return fetch('/cart/update.js', {
              method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin',
              body: JSON.stringify({ updates: updates })
            });
          })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin',
              body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
            });
          })
          .then(function (res) {
            if (!res || !res.ok) { throw new Error('add.js failed'); }
            window.location.href = '/checkout';
          })
          .catch(function () { window.location.href = permalink; });
      });
    });

    // ===== Header cart icon — visible only when the cart has items =====
    // Checks /cart.js on load AND on pageshow with e.persisted (bfcache restore),
    // so the icon appears when a shopper hits "Checkout now" then navigates back
    // to this page, or lands here having already added refills on another page.
    (function () {
      var link = document.getElementById('site-header-cart');
      if (!link || !window.fetch) return;
      function refresh() {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            if (!cart) return;
            var n = cart.item_count || 0;
            var count = document.getElementById('site-header-cart-count');
            if (count) { count.textContent = n > 99 ? '99+' : String(n); }
            link.hidden = (n === 0);
          })
          .catch(function () {});
      }
      refresh();
      window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    })();
